import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityComponent } from 'src/app/view/infrastructure/activity/activity.component';
import { CafeteriaComponent } from 'src/app/view/infrastructure/cafeteria/cafeteria.component';
import { ComputerComponent } from 'src/app/view/infrastructure/computer/computer.component';
import { FireComponent } from 'src/app/view/infrastructure/fire/fire.component';
import { HerbalComponent } from 'src/app/view/infrastructure/herbal/herbal.component';
import { InfrastructureComponent } from 'src/app/view/infrastructure/infrastructure.component';
import { LabsComponent } from 'src/app/view/infrastructure/labs/labs.component';
import { LibraryComponent } from 'src/app/view/infrastructure/library/library.component';
import { MedicalComponent } from 'src/app/view/infrastructure/medical/medical.component';
import { SchoolComponent } from 'src/app/view/infrastructure/school/school.component';
import { SmartComponent } from 'src/app/view/infrastructure/smart/smart.component';
import { SurveillanceComponent } from 'src/app/view/infrastructure/surveillance/surveillance.component';
import { TransportComponent } from 'src/app/view/infrastructure/transport/transport.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CampusComponent } from 'src/app/view/infrastructure/campus/campus.component';



@NgModule({
  declarations: [
    InfrastructureComponent,
    ComputerComponent,
    SmartComponent,
    LabsComponent,
    LibraryComponent,
    ActivityComponent,
    MedicalComponent,
    SchoolComponent,
    SurveillanceComponent,
    FireComponent,
    CafeteriaComponent,
    TransportComponent,
    HerbalComponent,
    CampusComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:InfrastructureComponent,children:[
        {path:'computer',component:ComputerComponent},
        {path:'smart',component:SmartComponent},
        {path:'labs',component:LabsComponent},
        {path:'library',component:LibraryComponent},
        {path:'activity',component:ActivityComponent},
        {path:'medical',component:MedicalComponent},
        {path:'school',component:SchoolComponent},
        {path:'surveillance',component:SurveillanceComponent},
        {path:'fire',component:FireComponent},
        {path:'cafeteria',component:CafeteriaComponent},
        {path:'transport',component:TransportComponent},
        {path:'herbal',component:HerbalComponent},
        {path:'campus',component:CampusComponent}
      ]}
    ]),
    SharedModule
  ]
})
export class InfrastructureModule { }
